import {
  RESERVE_STOCK,
  REVERT_STOCK_RESERVATION,
} from '../../../constants/actionConstants';
import {
  URL_STOCK_RESERVATION,
} from '../../../constants/endpointConstants';
import errorCodeConstants from '../../../constants/errorCodeConstants';
import { initPaymentPage } from './orderFormActions';
import { handleInvalidPartnerDiscountCardNumber } from '../partner-discount/partnerDiscountActions';
import handleInconsistentOrderFormState from '../../../utils/orderform/handleInconsistentOrderFormState';

export const reserveStock = () => ({
  type: RESERVE_STOCK,
  request: client => client({ path: URL_STOCK_RESERVATION, config: { method: 'POST' } }),
});

export const revertStockReservation = () => ({
  type: REVERT_STOCK_RESERVATION,
  request: client => client({ path: URL_STOCK_RESERVATION, config: { method: 'DELETE' } }),
});

export const handleReserveStock = () => async (dispatch) => {
  const reserveStockResponse = await dispatch(reserveStock());

  if (reserveStockResponse.type === `${RESERVE_STOCK}.FAILED`) {
    if (reserveStockResponse.error?.code === errorCodeConstants.PARTNER_CARD_NUMBER_INVALID) {
      await dispatch(handleInvalidPartnerDiscountCardNumber());
    } else if (reserveStockResponse.error?.code === errorCodeConstants.ORDER_FORM_INCONSISTENT_STATE) {
      await dispatch(handleInconsistentOrderFormState());
    } else {
      await dispatch(initPaymentPage());
    }
  }

  return reserveStockResponse;
};

export default handleReserveStock;
